<template>
  <v-dialog v-model="dialog" width="400px">
    <v-card>
      <v-card-title class="headline m-0">
        <v-flex xs9> <v-icon>warning</v-icon> Advertencia </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-2">
        <h3>¿Está seguro de enviar el cronograma de sus vacaciones?</h3>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()">
          NO
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="enviarCronogramaDetalle()"
          :loading="loading"
        >
          SI
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      form: {},
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogEnviarCronograma", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.form = {};
      this.loading = false;
      this.$bus.$emit("closeDialogEnviarCronograma");
    },
    async enviarCronogramaDetalle() {
      let respuesta;
      this.loading = true;
      let user = this.$storage.get("user");
      try {
        respuesta = await this.$service.graphql({
          query: `
               query{
                runQuery(consulta:"select vacaciones.fn_envia_vacacion_inmediato_superior(${parseInt(
                  this.form.id_estado_vacacion
                )},${user.id})"){
                  respuesta
                }
              }
            `
        });

        respuesta =
          respuesta.runQuery.respuesta[0].fn_envia_vacacion_inmediato_superior;
        let resps = respuesta.split("|");
        let correcto = resps[0];

        if (correcto === "1") {
          this.$confirm(
            "La programación fué enviada a la bandeja de su jefe inmediato",
            () => {
              this.loading = false;
              this.close();
            }
          );
        } else {
          this.$confirm(resps[1], () => {
            this.loading = false;
            this.close();
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/EnviarCronograma.vue